import React from 'react';

// Badge variant styles (replaces cva)
const badgeVariants = {
  default:
    'border-transparent bg-blue-600 text-white hover:bg-blue-500',
  secondary:
    'border-transparent bg-gray-200 text-gray-800 hover:bg-gray-300',
  destructive:
    'border-transparent bg-red-600 text-white hover:bg-red-500',
  outline:
    'text-gray-900 border-gray-300',
};

function Badge({ className = '', variant = 'default', children, ...props }) {
  const baseStyles =
    'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2';

  const variantStyles = badgeVariants[variant] || badgeVariants.default;

  return (
    <div
      className={`${baseStyles} ${variantStyles} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}

export { Badge, badgeVariants };